$.get("https://get.geojs.io/v1/ip/geo.json", function(response) {
  var visitorCountry = response.country;
  var visitorCountryCode = response.country_code;
  if ((visitorCountry && visitorCountry.toUpperCase() !== 'UNITED STATES')
    || (visitorCountryCode && visitorCountryCode.toUpperCase() !== 'US')) {
     if (enable_international_bar === false){
       $('#shopify-section-header').removeClass('add-top-height-international')
     } else {
       $('.international_announcement_bar').show()  
       appendInternationalContent()
     }
  } else {
    if (enable_domestic_bar === false){
       $('#shopify-section-header').removeClass('add-top-height-domestic')
     } else {
       $('.domestic_announcement_bar').show()
      appendDomesticContent()
     }
  }
}, "json");

function appendDomesticContent(){
  if(filteredDomesticContent && filteredDomesticContent.length){
    // Select the carousel cells and clear their content
    var carouselCells = document.querySelectorAll('.carousel-cell.Domestic_Announement_Bar_Content');
    carouselCells.forEach(function(cell) {
      cell.remove();
    });
    var DomesticSlider = $('.domestic-carousel').flickity();
    DomesticSlider.flickity('destroy');
    
    var htmlMain = '';
    filteredDomesticContent.forEach(function(content, index) {
      htmlMain += '<div class="carousel-cell Domestic_Announement_Bar_Content ' + (index === 0 ? 'is-selected' : '') + '" style="position: absolute; left: ' + (index * 100) + '%;" aria-hidden="false">';
      htmlMain += content;
      htmlMain += '</div>';
    });
    var carouselSlider = document.querySelector('.domestic-carousel');
    carouselSlider.innerHTML += htmlMain;
    
    // Re-initialize Flickity carousel
    var flkty = new Flickity('.domestic-carousel', {
      cellAlign: 'center',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: parseInt(domestic_bar_interval),
      pauseAutoPlayOnHover: true,
      draggable: true,
      prevNextButtons: true,
      wrapAround: true
    });
    
    /* Set BG Color */
    $('.domestic_announcement_bar').css("background-color", domestic_bg_color);

    /* Set Text Color */
    $('.Domestic_Announement_Bar_Content p').css("color", domestic_text_color);
    $('.Domestic_Announement_Bar_Content p a').css("color", domestic_text_color);
  }
}

function appendInternationalContent(){
  if(filteredInternationalContent && filteredInternationalContent.length){
    // Select the carousel cells and clear their content
    var carouselCells = document.querySelectorAll('.carousel-cell.International_Announement_Bar_Content');
    carouselCells.forEach(function(cell) {
      cell.remove();
    });
    var InternationalSlider = $('.international-carousel').flickity();
    InternationalSlider.flickity('destroy');

    var htmlMain = '';
    filteredInternationalContent.forEach(function(content, index) {
      htmlMain += '<div class="carousel-cell International_Announement_Bar_Content ' + (index === 0 ? 'is-selected' : '') + '" style="position: absolute; left: ' + (index * 100) + '%;" aria-hidden="false">';
      htmlMain += content;
      htmlMain += '</div>';
    });
    var carouselSlider = document.querySelector('.international-carousel');
    carouselSlider.innerHTML += htmlMain;
    
    // Re-initialize Flickity carousel
    var flkty = new Flickity('.international-carousel', {
      cellAlign: 'center',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: parseInt(international_bar_interval),
      pauseAutoPlayOnHover: true,
      draggable: true,
      prevNextButtons: true,
      wrapAround: true
    });
    
    /* Set BG Color */
    $('.international_announcement_bar').css("background-color", international_bg_color);

    /* Set Text Color */
    $('.International_Announement_Bar_Content p').css("color", international_text_color);
    $('.International_Announement_Bar_Content p a').css("color", international_text_color);
  }
}